export { SliderIndicator } from "./SliderIndicator";
export type { SliderIndicatorProps } from "./SliderIndicator";
